import type { IEntryAttachmentTarget } from 'common/enum/entry.attachment.enum';

export const entryAttachmentKeys = {
  all: ['entryAttachments'] as const,

  entry: (target: IEntryAttachmentTarget) => [...entryAttachmentKeys.all, target.entryType, target.entryId] as const,

  list: (target: IEntryAttachmentTarget, scope: readonly (number | undefined)[]) =>
    [...entryAttachmentKeys.entry(target), ...scope] as const,
};
